var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 4.6C10.6 4.26863 10.3314 4 10 4C9.66863 4 9.4 4.26863 9.4 4.6V9.39999H4.6C4.26863 9.39999 4 9.66862 4 9.99999C4 10.3314 4.26863 10.6 4.6 10.6H9.4V15.4C9.4 15.7314 9.66863 16 10 16C10.3314 16 10.6 15.7314 10.6 15.4V10.6H15.4C15.7314 10.6 16 10.3314 16 9.99999C16 9.66862 15.7314 9.39999 15.4 9.39999H10.6V4.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.fbfa41908cbe520243c53cbc3f204b0b.svg";
export { ForwardRef as ReactComponent };